export default __webpack_public_path__ + "static/media/img_textures.e07c0c46.png";